import { eventDashboard, srpEventDashboard } from 'api/pgads'
import { SRP_CLIENT } from 'client'

export const retrieveEventDashboardApi = clientId => {
  switch (clientId) {
    case SRP_CLIENT:
      return srpEventDashboard
    default:
      return eventDashboard
  }
}
